import type { RouteRecordRaw } from 'vue-router'
import { RouteList } from '@/routes/RouteList'
import { MenuCode } from '@/shared'
import { FeatureEnum } from '@/enums/FeatureEnum'
import { AbilityEnum } from '@/enums/AbilityEnum'

const NavBar = () => import('@/components/Layout/AuthenticatedNavBar.vue')
const SubSideBar = () => import('@/components/Layout/SubSideBar.vue')
const DashboardMain = () => import('@/components/Dashboard/DashboardMain.vue')
const SubjectBusinessListView = () => import('@/views/Enterprise/SubjectBusinessListView.vue')
const EnterpriseRoleListView = () => import('@/views/Enterprise/EnterpriseRoleListView.vue')
const EnterpriseUserListView = () => import('@/views/Enterprise/EnterpriseUserListView.vue')

export default <RouteRecordRaw[]>[
  {
    path: RouteList.ENTERPRISE.INDEX.PATH,
    name: RouteList.ENTERPRISE.INDEX.NAME,
    components: {
      default: DashboardMain,
      SideBar: SubSideBar,
      NavBar,
    },
    props: {
      SideBar: {
        menuCode: MenuCode.Enterprise,
        title: 'Enterprise',
      },
    },
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      feature: [FeatureEnum.ENTERPRISE],
      permission: [AbilityEnum.ENTERPRISE],
      title: 'Enterprise',
    },
    redirect: {
      name: RouteList.ENTERPRISE.SUBJECTS.INDEX.NAME,
    },
    children: [
      {
        path: RouteList.ENTERPRISE.SUBJECTS.INDEX.PATH,
        name: RouteList.ENTERPRISE.SUBJECTS.INDEX.NAME,
        component: SubjectBusinessListView,
        meta: {
          requiresAuth: true,
          requiresSubscription: true,
          feature: [FeatureEnum.ENTERPRISE_SUBJECT_BUSINESSES, FeatureEnum.ENTERPRISE],
          permission: [AbilityEnum.ENTERPRISE_SUBJECT_BUSINESSES, AbilityEnum.ENTERPRISE],
          title: 'Enterprise - Subject Businesses',
        },
      },
      {
        path: RouteList.ENTERPRISE.ROLES.INDEX.PATH,
        name: RouteList.ENTERPRISE.ROLES.INDEX.NAME,
        component: EnterpriseRoleListView,
        meta: {
          requiresAuth: true,
          requiresSubscription: true,
          feature: [
            FeatureEnum.ENTERPRISE_ACCESS_ROLES,
            FeatureEnum.ENTERPRISE_ACCESS,
            FeatureEnum.ENTERPRISE,
          ],
          permission: [
            AbilityEnum.ENTERPRISE_ACCESS_ROLES,
            AbilityEnum.ENTERPRISE_ACCESS,
            AbilityEnum.ENTERPRISE,
          ],
          title: 'Enterprise - Roles',
        },
      },
      {
        path: RouteList.ENTERPRISE.USERS.INDEX.PATH,
        name: RouteList.ENTERPRISE.USERS.INDEX.NAME,
        component: EnterpriseUserListView,
        meta: {
          requiresAuth: true,
          requiresSubscription: true,
          feature: [
            FeatureEnum.ENTERPRISE_ACCESS_USERS,
            FeatureEnum.ENTERPRISE_ACCESS,
            FeatureEnum.ENTERPRISE,
          ],
          permission: [
            AbilityEnum.ENTERPRISE_ACCESS_USERS,
            AbilityEnum.ENTERPRISE_ACCESS,
            AbilityEnum.ENTERPRISE,
          ],
          title: 'Enterprise - Users',
        },
      },
    ],
  },
]
